import { render, staticRenderFns } from "./details.page.vue?vue&type=template&id=e3cb1892&scoped=true"
import script from "./details.page.vue?vue&type=script&lang=js"
export * from "./details.page.vue?vue&type=script&lang=js"
import style0 from "./details.page.vue?vue&type=style&index=0&id=e3cb1892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cb1892",
  null
  
)

export default component.exports